import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { LanguageRouterLinkDirective } from '../../directives/language-router-link.directive';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-favorite-anonymous-modal',
  standalone: true,
  imports: [RouterModule, LanguageRouterLinkDirective, TranslocoDirective],
  templateUrl: './favorite-anonymous-modal.component.html',
  styleUrl: './favorite-anonymous-modal.component.css'
})
export class FavoriteAnonymousModalComponent {
  currentPath: string
  
  redirectToRegister(){
    this.authService.signinRedirect('/', { operation: 'register'});
  }

  constructor(private router: Router,private authService: AuthService) {
    this.currentPath = this.router.url;
  }
}
